// Descrição curta e ícone de cada tipo de regra, usados na lista de promoções
// e no cadastro. Tipos antigos (ex.: China in Box) caem no genérico.

const ICONES: any = {
  'percentual': 'fe-percent',
  'percentual-no-segundo': 'fe-copy',
  'percentual-todos': 'fe-shopping-bag',
  'adicionar-produto': 'fe-gift',
  'compre-pizza-ganhe-outra': 'fe-repeat'
};

export function iconeDaRegra(regra: any): string {
  return (regra && ICONES[regra.tipo]) || 'fe-tag';
}

function formatePercentual(valor: any): string {
  if (valor == null || valor === '') return '0%';

  return Number(valor).toLocaleString('pt-BR', { maximumFractionDigits: 2 }) + '%';
}

export function descrevaRegra(regra: any): string {
  if (!regra) return '';

  const percentual = formatePercentual(regra.percentual);
  const produto = regra.produto ? regra.produto.nome : 'produto';
  const alvo = regra.adicional ? regra.adicional.nome : produto;

  switch (regra.tipo) {
    case 'percentual':
      return `${percentual} de desconto em ${alvo}`;
    case 'percentual-no-segundo':
      return `${percentual} de desconto no segundo ${alvo}`;
    case 'percentual-todos':
      return `${percentual} de desconto em todos os produtos`;
    case 'adicionar-produto':
      return `${produto} entra no carrinho com ${percentual} de desconto`;
    case 'compre-pizza-ganhe-outra': {
      const comprar = regra.tamanhoPizzaComprar ? regra.tamanhoPizzaComprar.descricao : '?';
      const ganhar = regra.tamanhoPizzaGanhar ? regra.tamanhoPizzaGanhar.descricao : '?';

      return `Comprando ${regra.quantidade || 0} pizza(s) ${comprar}, ganha 1 pizza ${ganhar}`;
    }
    default:
      return regra.descricao || 'Regra da promoção';
  }
}
